export * from './types.js';
export { srdMonsters } from './monsters.js';
export {
  formatCr,
  sizeToTokenSize,
  typeToColor,
  buildTokenDescription,
  extractAuras,
  monsterToCharacterSheet,
  monsterToToken,
} from './mapping.js';

export { srdSpells } from './spells.js';
export { srdClasses } from './classes.js';
export { srdRaces } from './races.js';
export { srdEquipment } from './equipment.js';
export { srdConditions } from './conditions.js';
export { srdMagicItems } from './magic-items.js';
export * from './homebrew-data-schema.js';

import type { SrdEquipmentItem, SrdSpell } from './types.js';
import { srdEquipment as srdEquipmentList } from './equipment.js';
import { srdSpells as srdSpellList } from './spells.js';

/**
 * SRD equipment indexed by slug. Shared by the server (sheet-helpers) and the
 * client (hud-adapter) so AC derivation uses one identical equipment table.
 */
export const srdEquipmentMap: Map<string, SrdEquipmentItem> = new Map(
  srdEquipmentList.map((e) => [e.slug, e]),
);

/**
 * SRD spells indexed by slug. Passed to Dnd5eSheetAdapter.fromSheet so the HUD
 * can backfill school/components/ritual/concentration for legacy spellbook
 * entries persisted before those fields were stored (#spells P1).
 */
export const srdSpellMap: Map<string, SrdSpell> = new Map(
  srdSpellList.map((s) => [s.slug, s]),
);
